import { CButton } from "components/UI/Button/Buttons";
import { toast } from "sonner";

// const CheckBoxLabel = [
//   "I was an audience member,",
//   "I am a speaker",
//   "I organize events.",
// ];

const CheckBoxLabel = [
  "Selling Products & Services",
  "Email & Social Media Growth",
  "Partnerships & Collaborations",
  "Networking & Relationship Building",
  "Lead Generation & Contact Collection",
  "Audience Engagement & Market Research",
  "Speaking & Sponsorship Opportunities",
  "Event Participant",
];

const OnboardingSecondMainBody = ({
  onSubmit,
  isSubmitting,
  selectedValues,
  setSelectedValues,
}: {
  onSubmit: (usageTags: string[]) => void;
  isSubmitting: boolean;
  selectedValues: string[];
  setSelectedValues: React.Dispatch<React.SetStateAction<string[]>>;
}) => {
  const handleCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: string,
  ) => {
    if (event.target.checked) {
      setSelectedValues((prev) => [...prev, value]);
    } else {
      setSelectedValues((prev) => prev.filter((item) => item !== value));
    }
  };

  const submitPage = () => {
    if (selectedValues.length === 0) {
      toast.error("An option must be picked");
      return;
    }
    onSubmit(selectedValues);
  };

  return (
    <form className="flex flex-col gap-2">
      {CheckBoxLabel.map((dt: string, index: number) => (
        <div
          onClick={() => (document.getElementById(dt) as HTMLElement).click()}
          key={dt + index}
          className="flex gap-2 items-center rounded-lg py-2 px-4 border border-[#EAECF0] bg-[#FFFFFF] hover:border-[#FF6929] hover:bg-[#FFF8F5] transition-all duration-200 cursor-pointer"
        >
          <input
            onChange={(e) => handleCheckboxChange(e, dt)}
            type="checkbox"
            name={dt}
            id={dt}
            checked={selectedValues.includes(dt)}
            className="accent-[#FFF0EA] onboarding pointer-events-none"
          />

          <label
            className="font-grotesk font-normal text-sm pointer-events-none"
            htmlFor={dt}
          >
            {dt}
          </label>
        </div>
      ))}
      {
        <>
          <div className="mt-5">
            <CButton
              text={"Complete Setup"}
              loading={isSubmitting}
              variant="dark"
              fullWidth
              action={submitPage}
              disabled={selectedValues.length === 0}
            />
          </div>
        </>
      }
    </form>
  );
};

export default OnboardingSecondMainBody;
